@let portfolioIdValue = portfolioId();
@if (portfolioIdValue) {
  <cfp-report-buildings-download-button
    [portfolioId]="portfolioIdValue"
    [fileName]="fileName()"
    [buttonOutline]="false"
    [reportPath]="'retll'"
    [translationModule]="'lbg-portfolio-roadmap-report'"
    [downloadLabelKey]="'lbgPortfolioRoadmapReport.download'"
    [dataAnalytics]="'lbgPortfolioRoadmapReportDownload'"
  />
}
